import { computed } from "mobx";
import { observer } from "mobx-react";
import * as React from "react";
import { CloseButton } from "../Buttons/CloseButton";
import { ConfirmButton } from "../Buttons/ConfirmButton";
import { NextButton } from "../Buttons/NextButton";
import { RejectButton } from "../Buttons/RejectButton";
import { IWizardStore } from "../Stores/AppStore";
import { Strings } from "../Stores/StringsStore";
import { TypeAheadSearchInput } from "./TypeAheadSearchInput";
import { HierarchyMetaValuesWizardStore } from "../Stores/HierarchyMetaValuesWizardStore";

export enum WizardBoxType {
	Hierarchy,
	DocumentLink,
	ConfirmReject,
	Next,
	Confirm
}

export interface IWizardBoxProps {
	context: IWizardStore;
	type: WizardBoxType;
	className?: string;
}

@observer
export class WizardBox extends React.Component<IWizardBoxProps, {}> {

	handleYes = () => {
		this.props.context.onConfirmWizard();
	}

	handleNo = () => {
		this.props.context.wizardCaption = "";
		this.props.context.wizardInformation = "";
		this.props.context.wizardWarningText = "";
		this.props.context.wizardWarning = false;
		this.props.context.onCancelWizard();
	}

	@computed get wizardBoxClass() {
		return (this.props.context.wizardWarning ? "wizardbox is--wizard-warning" : "wizardbox") + (this.props.className ? " " + this.props.className : "");
	}

	handleSearchTermChangeFromTypeAhead = (searchTerm: string) => {
		(this.props.context as HierarchyMetaValuesWizardStore).searchTerm = searchTerm;
	}

	render() {
		return <div className="dialogbox-wrapper is--dialog-open">

			<div className={this.wizardBoxClass} data-test-id="wizardBox">

				<div className="wizardbox-head">
					<span className="wizardbox-head__control">
						<div className="tinytool">
							<CloseButton onClick={this.handleNo} testId="wizardBoxCloseButton" />
						</div>
					</span>
					<h2>{this.props.context.wizardCaption}</h2>
					<p>{this.props.context.wizardInformation}</p>
					{this.props.type === WizardBoxType.Hierarchy ? <TypeAheadSearchInput showSuggestionList={false} searchTermChangeCallback={this.handleSearchTermChangeFromTypeAhead} /> : null}
				</div>
				{this.props.children}
				{this.props.context.isWizardBoxBusy ? <div className="spinner">
					<div className="spinner-inner">

						<i>
							<svg className="spinner-animation" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48">
								<path className="spinner-custom" d="M24,5A19,19,0,0,1,43,24h3A22,22,0,0,0,24,2Z" />
								<path d="M24,43A19,19,0,0,1,24,5V2A22,22,0,1,0,46,24H43A19,19,0,0,1,24,43Z" />
							</svg>
						</i>

					</div>
					<div className="spinner-label">Loading</div>
				</div> : null}


				<div className="wizardbox-note is--note-error">{this.props.context.wizardWarningText}</div>

				<div className="wizardbox-toolbar">
					{this.props.type === WizardBoxType.ConfirmReject
						? [<ConfirmButton title={Strings.general.ok} onClick={this.handleYes} disabled={this.props.context.wizardWarning} testId="wizardBoxConfirmButton" />,
						<span className="buttongroup is--buttongroup-right">
							<RejectButton onClick={this.handleNo} testId="wizardBoxCancelButton" />
						</span>]
						: this.props.type === WizardBoxType.Next
							? <span className="buttongroup is--buttongroup-right">
								<NextButton onClick={this.handleYes} disabled={this.props.context.wizardWarning || !this.props.context.confirmEnabled} testId="wizardBoxConfirmButton" />
							</span>
							: this.props.type === WizardBoxType.Hierarchy
								? [<ConfirmButton title={Strings.documentManagement.documentEdit.addSelectedValues} label={Strings.documentManagement.documentEdit.addSelectedValues} onClick={this.handleYes} disabled={this.props.context.wizardWarning || !this.props.context.confirmEnabled} testId="wizardBoxConfirmButton" />,
								<span className="buttongroup is--buttongroup-right">
									<RejectButton onClick={this.handleNo} testId="wizardBoxCancelButton" />
									</span>]
								: this.props.type === WizardBoxType.DocumentLink
									? [<ConfirmButton title={Strings.documentManagement.documentEdit.addSelectedDocumentLink} label={Strings.documentManagement.documentEdit.addSelectedDocumentLink} onClick={this.handleYes} disabled={this.props.context.wizardWarning || !this.props.context.confirmEnabled} testId="wizardBoxConfirmButton" />,
									<span className="buttongroup is--buttongroup-right">
										<RejectButton onClick={this.handleNo} testId="wizardBoxCancelButton" />
									</span>]
							: <span className="buttongroup is--buttongroup-right">
								<ConfirmButton title={Strings.general.ok} onClick={this.handleYes} disabled={this.props.context.wizardWarning || !this.props.context.confirmEnabled} testId="wizardBoxConfirmButton" />
							</span>
					}
				</div>

			</div>
		</div>;
	}
}